import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Check: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEmail2Check"><Path d="M12 19.5H2.5V4.5H21.5L21.5 7.25L12 12.0714L2.73768 7.37063" stroke="currentColor"/><Path d="M22.5 13L17.5 19.5L15 17" stroke="currentColor"/></CentralIconBase>;
});

export default IconEmail2Check;
